import React, { useEffect, useState } from 'react';
import './HeroSlideshow.css';

const SLIDE_MS = 6000;

// Arka planda yavas gecisli fotograf slayti.
// Tek fotograf varsa slayt durur, sabit kare gibi davranir.
const HeroSlideshow = ({ images }) => {
  const [active, setActive] = useState(0);
  const count = images.length;

  useEffect(() => {
    if (count < 2) return undefined;

    const reduceMotion =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return undefined;

    const timer = setInterval(() => {
      setActive((current) => (current + 1) % count);
    }, SLIDE_MS);

    return () => clearInterval(timer);
  }, [count]);

  if (count === 0) return null;

  return (
    <div className="slideshow" aria-hidden="true">
      {images.map((image, index) => (
        <div
          key={image.src}
          className={`slideshow__frame${index === active ? ' is-active' : ''}`}
        >
          <img
            src={image.src}
            alt=""
            loading={index === 0 ? 'eager' : 'lazy'}
            decoding="async"
          />
        </div>
      ))}

      <div className="slideshow__scrim" />

      {count > 1 ? (
        <div className="slideshow__dots">
          {images.map((image, index) => (
            <span
              key={image.src}
              className={`slideshow__dot${index === active ? ' is-active' : ''}`}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default HeroSlideshow;
